export default {
  alreadySentTitleSsn: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_preview_description',
    defaultMessage: 'You have already entered the following SSN last 4 digits.',
  },
  alreadySentTitleFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_preview_description',
    defaultMessage: 'You have already entered the following SSN:',
  },
  alreadySentTitleDrivingLicense: {
    id: 'buyback_my_sales_bank_details_modal_driving_license_view_preview_description',
    defaultMessage:
      'You have already entered the following driver’s license number.',
  },
  alreadySentDescriptionSsn: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_preview_value',
    defaultMessage: 'Last 4 digits of your SSN',
  },
  alreadySentDescriptionFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_preview_value',
    defaultMessage: 'Social Security Number',
  },
  alreadySentDescriptionDrivingLicense: {
    id: 'buyback_my_sales_bank_details_modal_driving_license_view_preview_value',
    defaultMessage: 'Driver’s license number',
  },
  ssn: {
    id: 'buyback_my_sales_bank_details_identity_verification_choice_ssn_number',
    defaultMessage: 'Last 4 digits of SSN',
  },
  fullSsn: {
    id: 'buyback_my_sales_bank_details_identity_verification_choice_full_ssn_number',
    defaultMessage: '12 digits of SSN',
  },
  drivingLicense: {
    id: 'buyback_my_sales_bank_details_identity_verification_choice_driving_license_number',
    defaultMessage: 'Driver’s license number',
  },
  identityInformationsChoiceText: {
    id: 'buyback_my_sales_bank_details_identity_verification_description',
    defaultMessage:
      'We need to confirm your identity to process your payment. You have 2 options: you can provide either your driver’s license number OR the last 4 digits of your Social Security Number (SSN).',
  },
  descriptionSsn: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_description',
    defaultMessage:
      'Please enter the last 4 digits of your SSN so we can securely confirm your identity.',
  },
  descriptionFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_description',
    defaultMessage:
      'Please enter your SSN so we can securely confirm your identity.',
  },
  descriptionDrivingLicense: {
    id: 'buyback_my_sales_bank_details_driving_license_description',
    defaultMessage:
      'Please enter your driver’s license number so we can securely confirm your identity.',
  },
  ssnPreviewLabel: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_input',
    defaultMessage: 'Last 4 digits of your SSN',
  },
  fullSsnPreviewLabel: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_input',
    defaultMessage: 'Social Security Number',
  },
  drivingLicensePreviewLabel: {
    id: 'buyback_my_sales_bank_details_driving_license_label',
    defaultMessage: "Driver's license",
  },
  infoBlockTitleSsn: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_info_title',
    defaultMessage: 'Why we need your SSN',
  },
  infoBlockTitleFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_info_title',
    defaultMessage: 'Why do we need your full SSN?',
  },
  infoBlockTitleDrivingLicense: {
    id: 'buyback_my_sales_bank_details_driving_license_info_title',
    defaultMessage: 'Why we need your driver’s license',
  },
  infoBlockDescriptionSsn: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_info_description',
    defaultMessage:
      'Our payment provider, Adyen requires us to confirm your identity. Otherwise, we can’t process your payment.\nYour SSN will be automatically deleted once your identity is confirmed and you have received your payment.\nYou can find your SSN on your Social Security card, tax returns, or bank statements. ',
  },
  infoBlockDescriptionFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_info_description',
    defaultMessage:
      'Our payment provider requires your SSN to confirm your identity in order to pay you. \n Additionally, Back Market is required to report Trade-in transactions of $2,500 or more (per calendar year) to the IRS. \n Your SSN will be automatically deleted once your identity is confirmed and you have received your payment.',
  },
  infoBlockDescriptionDrivingLicense: {
    id: 'buyback_my_sales_bank_details_driving_license_info_description',
    defaultMessage:
      'Our payment provider, Adyen requires us to confirm your identity. Otherwise, we can’t process your payment.\nYour driver’s license number will be automatically deleted once your identity is confirmed and you have received your payment.',
  },
  choiceInfoBlockContent: {
    id: 'buyback_my_sales_bank_details_identity_verification_info_description',
    defaultMessage:
      'We work closely with our payment partner, Adyen to confirm your identity, transfer money to your bank account, and prevent fraud.',
  },
  choiceInfoBlockTitle: {
    id: 'buyback_my_sales_bank_details_identity_verification_info_title',
    defaultMessage: 'How we protect your data',
  },
  required: {
    id: 'buyback_shared_required_field',
    defaultMessage: 'This field is required',
  },
  lengthError: {
    id: 'buyback_my_sales_bank_details_modal_ssn_view_error_length',
    defaultMessage:
      'You must provide the last 4 digits of your social security number',
  },
  lengthErrorFullSsn: {
    id: 'buyback_my_sales_bank_details_modal_full_ssn_view_error_length',
    defaultMessage:
      'You must provide the 9 digits of your social security number',
  },
  formatError: {
    id: 'buyback_my_sales_bank_details_modal_driving_license_format_error',
    defaultMessage:
      "Driver's licence should only accept alphanumeric characters and dash",
  },
  agentPreviewDescription: {
    id: 'buyback_admin_order_ssn_modal_description',
    defaultMessage:
      'This Back Market customer has already entered their identity verification information.',
  },
  descriptionAgent: {
    id: 'buyback_admin_order_ssn_modal_ssn_view_description',
    defaultMessage:
      'Please choose the personal identification you want to provide',
  },
}
